import { appServices } from '../helpers/app-services/AppServices';

export const saveTemplate = async scribeId => {
  try {
    return await appServices.createTemplateFromProject(scribeId);
  } catch (error) {
    console.error('Failed to save project as a template in App Services', error);
  }
};
